import { render } from "./Instructions.vue?vue&type=template&id=fa89911a&scoped=true"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=fa89911a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa89911a"]])

export default __exports__